import { Link } from 'gatsby'
import React from 'react'
import Helmet from 'react-helmet'
import Apps from '../components/Apps'
import Beta from '../components/Beta'
import Layout from '../components/layout'
import Loading from '../components/Loading';
import Contact from '../components/Contact'
import CreateProfile from '../components/CreateProfile'
import CustomAutocomplete from '../components/search/AutoCompletePlacesTest'
import { translate } from "react-i18next"
import FloatingWhatsApp from 'react-floating-whatsapp'
import 'react-floating-whatsapp/dist/index.css'

import avatar from '../assets/images/wa_avatar.jpg'

var isLoading = false;

class HomeIndex extends React.Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this)
    this.state = {
      message: "",
      isApp: false,
    };
  }

  handler() {
    this.setState({
      isApp: false,
    })
  }

  render() {
    const { t } = this.props
    return (
      <>
      {isLoading ? (<><Loading/></>) : (<></>)}
      <Layout cl="" handler={this.handler}>
        <Helmet
          title="WFOW"
          meta={[
            { name: 'description', content: 'Das Netzwerk für Gründerinnen und etablierte Frauenunternehmen. WORLD FULL OF WOMEN ist ein Verzeichnis von Frauen, die sich selbstständig gemacht haben. Unternehmerinnen können hier schnell und einfach gefunden werden. Registrierung und Nutzung kostenlos.' },
            { name: 'keywords', content: 'wfow, worldfullofwomen, world full of women, unternehmerin, unternehmerinnen, frauen, frauenunternehmen, gründerin, gründen, frauennetzwerk, female founders, selbstständig' },
          ]}
        ></Helmet>
        <CustomAutocomplete amount={6}/>
        <div id="main" className="">
            <section id="two">
                <div className="inner">
                  <p>{t("index_womap_text", "Weitere einzigartige Frauen kannst du auf unserer WOMAP finden.")}</p>
                      <Link
                        aria-label="Link to WoMap"
                        to="/womap"
                        className="button next"
                      >
                        WOMAP
                      </Link>
                      <br/><br/>
                </div>
            </section>
          {/* <Beta /> */}
          {this.state.isApp ? (<></>) : (<><Apps /></>)}
          <CreateProfile />
          {/* <Contact /> */}
          {this.state.isApp ? null : (
            <>
              <FloatingWhatsApp 
                phoneNumber="491632221616"
                statusMessage={t("whatsapp_status", "Antwortet in der Regel innerhalb von einem Tag")} 
                chatMessage={t("whatsapp_message", "Wie kann ich dir helfen?")} 
                accountName="Hila"
                avatar={avatar}
                darkMode={false}
                />
            </>
          )}
        </div>
      </Layout>
      </>
    )
  }
}

export default translate("Index")(HomeIndex)